import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';
import { conditionalConfigSchema } from '../utils/conditionalConfig.js';

export const ConditionalBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.Conditional),
  config: conditionalConfigSchema,
});
export type ConditionalBlock = z.infer<typeof ConditionalBlockSchema>;
